import { AgentSkill, QueryParams } from "@/sharedTypes";
import { baseApi } from "../baseApi";
import { flattenQueryParams } from "@/utils/requestUtils";

const agentSkillTag = "AgentSkill";

export const agentSkillApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAgentSkills: builder.query<any, QueryParams>({
      query: (params) => {
        const queryString = params
          ? `?${new URLSearchParams(flattenQueryParams(params)).toString()}`
          : "";
        return `/agent-skills${queryString}`;
      },
      providesTags: [agentSkillTag],
    }),
    addSubcategorySkills: builder.mutation<
      any,
      { agent_id: number; skills: { subcategory_id: number; skill_rate: number }[] }
    >({
      query: (body) => ({
        url: `/agent-skills/`,
        method: "POST",
        body,
      }),
      invalidatesTags: [agentSkillTag],
    }),
    updateAgentSkill: builder.mutation<
      any,
      { id: number; data: { subcategory_id: number; skill_rate: number } }
    >({
      query: ({ id, data }) => ({
        url: `/agent-skills/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: [agentSkillTag, "Subcategory"],
    }),
    deleteAgentSkill: builder.mutation<any, number>({
      query: (id) => ({
        url: `/agent-skills/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [agentSkillTag, "Subcategory"],
    }),
  }),
});

export const {
  useGetAgentSkillsQuery,
  useAddSubcategorySkillsMutation,
  useUpdateAgentSkillMutation,
  useDeleteAgentSkillMutation,
} = agentSkillApi;
